import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import API_BASE from '../api';

const API_ORIGIN = API_BASE.replace(/\/api$/, '');

const WA_NUMBER = '9720546318704';

const WA_ICON = <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.847L.057 23.882l6.197-1.448A11.934 11.934 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.894a9.876 9.876 0 0 1-5.031-1.378l-.361-.214-3.741.981.998-3.648-.235-.374A9.867 9.867 0 0 1 2.106 12C2.106 6.535 6.535 2.106 12 2.106c5.466 0 9.894 4.429 9.894 9.894 0 5.466-4.428 9.894-9.894 9.894z"/></svg>;
const YT_ICON = <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1C4.5 20.5 12 20.5 12 20.5s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.7 15.5V8.5l6.3 3.5-6.3 3.5z"/></svg>;
const PHONE_ICON = <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>;

// ── תרגומים — הדף עובר לאנגלית כשגרפיקת הפרופיל היא באנגלית ──
const STRINGS = {
  he: {
    tagline: 'פרופיל שחקן מקצועי מבית יוסטאר',
    badge: season => `⭐ פרופיל שחקן מקצועי · עונת ${season}`,
    statPosition: 'תפקיד', statShirt: 'חולצה', statBorn: 'שנתון', statAgeGroup: 'שכבה',
    clipsTitle: n => `🎬 קליפי הביצועים${n > 1 ? ` (${n})` : ''}`,
    galleryTitle: n => `🖼️ גלריית תמונות${n > 1 ? ` (${n})` : ''}`,
    clipsComingSoon: 'הקליפים בדרך — נעדכן כאן ברגע שיהיו מוכנים 🎬',
    against: 'נגד', season: 'עונת', watchYoutube: 'צפייה ביוטיוב', nowPlaying: '▶ מתנגן',
    shareTitle: first => `📣 שתפו את הפרופיל של ${first}`,
    shareText: first => `שלחו את האתר האישי למאמנים, למשפחה ולחברים — כרטיס הביקור של ${first} על המגרש.`,
    shareWA: 'שיתוף בוואטסאפ', copyLink: '🔗 העתקת קישור', linkCopied: '✅ הקישור הועתק',
    footerCredit: () => <>הפרופיל הופק על ידי <strong style={{ color:'#d4af37' }}>יוסטאר</strong> — מייצרים קליפי ביצועים ופרופילים מקצועיים לשחקני כדורגל צעירים.</>,
    waUstar: 'וואטסאפ יוסטאר', ytChannel: 'ערוץ היוטיוב',
    referral: 'רוצים פרופיל כזה גם לילד/ה שלכם? דברו איתנו בוואטסאפ',
    referralMsg: name => `שלום! ראיתי את הפרופיל של ${name} ואשמח לשמוע איך מכינים פרופיל כזה גם לילד/ה שלי ⭐`,
    rights: y => `© ${y} יוסטאר — כל הזכויות שמורות`,
    shareText2: (name, team, ageGroup, url) => `⚽ הפרופיל המקצועי של ${name} — ${team} ${ageGroup}\nכל קליפי הביצועים במקום אחד 🎬\n${url}`,
    matchCategory: { 'אימון':'אימון', 'ליגה':'ליגה', 'גביע':'גביע', 'טורניר':'טורניר' },
  },
  en: {
    tagline: 'Professional player profile by U-STAR',
    badge: season => `⭐ Professional Player Profile · ${season} Season`,
    statPosition: 'Position', statShirt: 'Number', statBorn: 'Born', statAgeGroup: 'Age Group',
    clipsTitle: n => `🎬 Performance Clips${n > 1 ? ` (${n})` : ''}`,
    galleryTitle: n => `🖼️ Photo Gallery${n > 1 ? ` (${n})` : ''}`,
    clipsComingSoon: "Clips coming soon — we'll update here once they're ready 🎬",
    against: 'vs', season: 'Season', watchYoutube: 'Watch on YouTube', nowPlaying: '▶ Playing',
    shareTitle: first => `📣 Share ${first}'s profile`,
    shareText: first => `Send the personal site to coaches, family and friends — ${first}'s calling card on the pitch.`,
    shareWA: 'Share on WhatsApp', copyLink: '🔗 Copy link', linkCopied: '✅ Link copied',
    footerCredit: () => <>Profile produced by <strong style={{ color:'#d4af37' }}>U-STAR</strong> — professional performance clips and player profiles for young football players.</>,
    waUstar: 'WhatsApp U-STAR', ytChannel: 'YouTube channel',
    referral: 'Want a profile like this for your child? Talk to us on WhatsApp',
    referralMsg: name => `Hi! I saw ${name}'s profile and would love to hear how to make one like it for my child too ⭐`,
    rights: y => `© ${y} U-STAR — All rights reserved`,
    shareText2: (name, team, ageGroup, url) => `⚽ ${name}'s professional profile — ${team} ${ageGroup}\nAll performance clips in one place 🎬\n${url}`,
    matchCategory: { 'אימון':'Training', 'ליגה':'League', 'גביע':'Cup', 'טורניר':'Tournament' },
  },
};

// ── לוגו המותג — U-STAR Profile ──────────────────────────────
// hero — באנר רחב ובולט בראש הדף · big — לוגו בפוטר · normal — קטן
function BrandLockup({ size = 'normal' }) {
  const hero = size === 'hero';
  const big = size === 'big';
  return (
    <img src="/ustarpro.png" alt="U-STAR Profile" style={
      hero
        ? { width:'min(94%, 560px)', display:'block', margin:'0 auto', borderRadius:16,
            border:'1px solid rgba(212,175,55,0.45)', boxShadow:'0 10px 40px rgba(0,0,0,0.55)' }
        : {
            height: big ? 'clamp(52px,10vw,84px)' : 40,
            borderRadius: big ? 12 : 8,
            border:'1px solid rgba(212,175,55,0.4)',
            boxShadow:'0 6px 24px rgba(0,0,0,0.5)',
            display:'block',
          }
    } />
  );
}

function StatBox({ label, value }) {
  // ערך ריק — לא מציגים משבצת ריקה (למשל שחקן בלי מספר חולצה)
  const text = String(value ?? '').trim();
  if (!text) return null;
  // ערכים קצרים ("נערים ב") נשארים בשורה אחת; ערכים ארוכים ("בלם / מגן / קשר אחורי")
  // נשברים לשורות ומוקטנים מעט, כדי שיישבו בנוח בתוך המשבצת.
  const long = text.length > 9;
  return (
    <div style={{ background:'rgba(10,20,45,0.55)', backdropFilter:'blur(6px)', border:'1px solid rgba(212,175,55,0.28)', borderRadius:12, padding:'14px 10px', textAlign:'center', minWidth:0, display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <div style={{ color:'#f0cc60', fontWeight:900,
        fontSize: long ? 'clamp(0.82rem,2.6vw,1.02rem)' : 'clamp(0.95rem,3.3vw,1.3rem)',
        lineHeight:1.3, whiteSpace: long ? 'normal' : 'nowrap', overflowWrap:'break-word' }}>{text}</div>
      <div style={{ color:'#a8b6d8', fontSize:'0.76rem', fontWeight:600, marginTop:5 }}>{label}</div>
    </div>
  );
}

// רקע יוסטאר — רצועה מוגדרת מאחורי הנתונים (החלק שאין לו גרפיקה ייעודית)
const heroStripStyle = {
  backgroundImage: "radial-gradient(ellipse 120% 100% at 50% 30%, rgba(4,9,26,0.15), rgba(4,9,26,0.65) 65%, #04091a 100%), url('/family-hero.jpg')",
  backgroundSize: 'cover',
  backgroundPosition: 'center 68%',
};

export default function PlayerPage() {
  const { slug } = useParams();
  const [player, setPlayer] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [copied, setCopied] = useState(false);
  const [activeClip, setActiveClip] = useState(0);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    setPlayer(null); setNotFound(false); setActiveClip(0);
    axios.get(`${API_BASE}/player-profiles/${slug}`)
      .then(r => setPlayer({ ...r.data, graphic: r.data.graphic ? API_ORIGIN + r.data.graphic : null, photos: (r.data.photos || []).map(p => API_ORIGIN + p) }))
      .catch(() => setNotFound(true));
  }, [slug]);

  const isEn = player?.language === 'en';
  const T = STRINGS[isEn ? 'en' : 'he'];
  const dir = isEn ? 'ltr' : 'rtl';

  useEffect(() => {
    if (player) document.title = isEn
      ? `${player.name} — Professional Player Profile | U-STAR Profile`
      : `${player.name} — פרופיל שחקן מקצועי | U-STAR Profile`;
  }, [player, isEn]);

  if (notFound) {
    return (
      <div style={{ minHeight:'100vh', background:'#04091a', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:24, direction:'rtl' }}>
        <div style={{ marginBottom:28 }}><BrandLockup size="big" /></div>
        <div style={{ color:'#c0cce6', fontSize:'1.1rem', marginBottom:20 }}>הדף לא נמצא</div>
        <a href="/" style={{ color:'#d4af37', textDecoration:'none', fontWeight:700 }}>← לדף הבית של יוסטאר</a>
      </div>
    );
  }

  if (!player) {
    return (
      <div style={{ minHeight:'100vh', background:'#04091a', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <BrandLockup size="big" />
      </div>
    );
  }

  const url = typeof window !== 'undefined' ? window.location.href : '';
  const shareText = T.shareText2(player.name, player.team, player.ageGroup, url);
  const clipCategory = c => c.matchCategory ? (T.matchCategory[c.matchCategory] || c.matchCategory) : '';

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch { /* ignore */ }
  };

  return (
    <div style={{ direction: dir, fontFamily:"'Heebo', sans-serif", minHeight:'100vh', background:'#04091a' }}>

      {/* ── פס עליון — לוגו U-STAR Profile, בולט ── */}
      <div style={{ background:'linear-gradient(180deg, rgba(2,6,17,0.96), rgba(2,6,17,0.8))', borderBottom:'1px solid rgba(212,175,55,0.25)', padding:'18px 16px', textAlign:'center' }}>
        <BrandLockup size="hero" />
        <div style={{ color:'#7a8bb0', fontSize:'0.78rem', fontWeight:600, marginTop:10, letterSpacing:'0.02em' }}>
          {T.tagline}
        </div>
      </div>

      {/* ===== גרפיקת הפרופיל של השחקן — HERO ===== */}
      <div style={{ padding:'22px 16px 4px', lineHeight:0 }}>
        <div style={{ maxWidth:1100, margin:'0 auto', borderRadius:18, overflow:'hidden', boxShadow:'0 20px 70px rgba(0,0,0,0.65), 0 0 0 1px rgba(212,175,55,0.25)' }}>
          <img src={player.graphic} alt={player.name} style={{ width:'100%', display:'block' }} />
        </div>
      </div>

      {/* ===== כותרת + נתוני שחקן — רצועת רקע יוסטאר ===== */}
      <div style={heroStripStyle}>
      <div style={{ maxWidth:900, margin:'0 auto', padding:'40px 20px 34px', textAlign:'center' }}>
        <h1 style={{ color:'#fff', fontWeight:900, fontSize:'clamp(1.8rem,6vw,2.8rem)', margin:'0 0 8px', letterSpacing:'-0.01em', textShadow:'0 4px 30px rgba(0,0,0,0.6)' }}>
          {player.name}
        </h1>
        <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(212,175,55,0.14)', border:'1px solid rgba(212,175,55,0.45)', borderRadius:30, padding:'6px 18px', color:'#f0cc60', fontWeight:800, fontSize:'clamp(0.82rem,2.4vw,0.95rem)' }}>
          {T.badge(player.season)}
        </div>

        {/* בפלאפון 2 עמודות (מקום אמיתי לטקסט עברי), 4 כשיש רוחב. משבצות ריקות לא מוצגות. */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(130px,1fr))', gap:10, margin:'28px 0 8px' }}>
          <StatBox label={T.statPosition} value={player.position} />
          <StatBox label={T.statShirt} value={player.shirt} />
          <StatBox label={T.statBorn} value={player.birthYear} />
          <StatBox label={T.statAgeGroup} value={player.ageGroup} />
        </div>
        <div style={{ color:'#dbe2f0', fontSize:'clamp(0.95rem,2.5vw,1.1rem)', fontWeight:700, marginTop:14 }}>
          {player.team}
        </div>
      </div>
      </div>

      {/* ===== כל קליפי הביצועים — כל הסרטונים של השחקן במקום אחד ===== */}
      <div style={{ maxWidth:900, margin:'0 auto', padding:'34px 20px 8px' }}>
        <div style={{ textAlign:'center', marginBottom:6 }}>
          <span style={{ display:'inline-flex', alignItems:'center', gap:9, color:'#fff', fontWeight:900, fontSize:'clamp(1.3rem,4vw,1.8rem)' }}>
            {T.clipsTitle(player.clips.length)}
          </span>
        </div>
        {player.clips.length === 0 ? (
          <div style={{ textAlign:'center', color:'#5a6a90', padding:'30px 20px' }}>{T.clipsComingSoon}</div>
        ) : (() => {
          const clip = player.clips[activeClip] || player.clips[0];
          return (
            <>
              <div style={{ color:'#a8b6d8', textAlign:'center', fontSize:'0.92rem', marginBottom:18 }}>
                {clipCategory(clip) ? `${clipCategory(clip)} · ` : ''}{T.against} {clip.opponent} · {clip.ageGroup} · {T.season} {clip.season}{clip.date ? ` · ${clip.date}` : ''}
              </div>

              <div style={{ position:'relative', paddingBottom:'56.25%', height:0, borderRadius:16, overflow:'hidden',
                border:'1px solid rgba(212,175,55,0.4)', boxShadow:'0 20px 70px rgba(0,0,0,0.7)', background:'#000' }}>
                <iframe
                  key={clip.youtubeId}
                  src={`https://www.youtube.com/embed/${clip.youtubeId}?rel=0&modestbranding=1`}
                  title={`${player.name} — clip`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%', border:'none' }}
                />
              </div>

              <div style={{ textAlign:'center', marginTop:14 }}>
                <a href={`https://www.youtube.com/watch?v=${clip.youtubeId}`} target="_blank" rel="noopener noreferrer"
                  style={{ display:'inline-flex', alignItems:'center', gap:8, color:'#ff5555', textDecoration:'none', fontSize:'0.88rem', fontWeight:700 }}>
                  {YT_ICON} {T.watchYoutube}
                </a>
              </div>
            </>
          );
        })()}

        {/* גלריית כל הקליפים — לבחירה */}
        {player.clips.length > 1 && (
          <div style={{ display:'flex', gap:10, overflowX:'auto', padding:'26px 2px 6px', marginTop:6 }}>
            {player.clips.map((clip, i) => {
              const active = i === activeClip;
              return (
                <button key={clip.youtubeId} onClick={() => setActiveClip(i)}
                  style={{ flex:'0 0 auto', width:170, cursor:'pointer', background:'none', border:'none', padding:0, textAlign: isEn ? 'left' : 'right' }}>
                  <div style={{ position:'relative', borderRadius:10, overflow:'hidden',
                    border: active ? '2px solid #f0cc60' : '1px solid rgba(212,175,55,0.3)',
                    boxShadow: active ? '0 0 0 3px rgba(212,175,55,0.2)' : 'none', opacity: active ? 1 : 0.75 }}>
                    <img src={`https://img.youtube.com/vi/${clip.youtubeId}/hqdefault.jpg`} alt={`${T.against} ${clip.opponent}`}
                      style={{ width:'100%', display:'block', aspectRatio:'16/9', objectFit:'cover' }} />
                    {active && (
                      <div style={{ position:'absolute', bottom:6, [isEn?'right':'left']:6, background:'#f0cc60', color:'#0a1120', borderRadius:6, padding:'1px 8px', fontSize:'0.68rem', fontWeight:900 }}>{T.nowPlaying}</div>
                    )}
                  </div>
                  <div style={{ color: active ? '#f0cc60' : '#c8d0e6', fontWeight:700, fontSize:'0.78rem', marginTop:6, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {T.against} {clip.opponent}
                  </div>
                  <div style={{ color:'#6a7ba0', fontSize:'0.7rem' }}>{clip.date}</div>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* ===== גלריית תמונות ===== */}
      {player.photos && player.photos.length > 0 && (
        <div style={{ maxWidth:900, margin:'0 auto', padding:'10px 20px 8px' }}>
          <div style={{ textAlign:'center', marginBottom:16 }}>
            <span style={{ display:'inline-flex', alignItems:'center', gap:9, color:'#fff', fontWeight:900, fontSize:'clamp(1.3rem,4vw,1.8rem)' }}>
              {T.galleryTitle(player.photos.length)}
            </span>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))', gap:10 }}>
            {player.photos.map((src, i) => (
              <button key={src} onClick={() => setLightbox(src)}
                style={{ padding:0, border:'1px solid rgba(212,175,55,0.3)', borderRadius:12, overflow:'hidden', cursor:'pointer', background:'none' }}>
                <img src={src} alt={`${player.name} ${i + 1}`}
                  style={{ width:'100%', display:'block', aspectRatio:'3/4', objectFit:'cover' }} />
              </button>
            ))}
          </div>
        </div>
      )}

      {/* לייטבוקס — הגדלת תמונה מהגלריה */}
      {lightbox && (
        <div onClick={() => setLightbox(null)}
          style={{ position:'fixed', inset:0, background:'rgba(2,6,17,0.94)', zIndex:50, display:'flex', alignItems:'center', justifyContent:'center', padding:20, cursor:'zoom-out' }}>
          <img src={lightbox} alt="" style={{ maxWidth:'100%', maxHeight:'90vh', borderRadius:12, boxShadow:'0 20px 70px rgba(0,0,0,0.7)' }} />
          <button onClick={() => setLightbox(null)}
            style={{ position:'absolute', top:18, [isEn?'right':'left']:18, background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.3)', color:'#fff', borderRadius:'50%', width:38, height:38, fontSize:'1.2rem', cursor:'pointer' }}>×</button>
        </div>
      )}

      {/* ===== שיתוף — נגיש להורה שנכנס לאתר ===== */}
      <div style={{ maxWidth:640, margin:'0 auto', padding:'36px 20px 10px' }}>
        <div style={{ background:'linear-gradient(135deg, rgba(212,175,55,0.14), rgba(10,20,45,0.6))', border:'1px solid rgba(212,175,55,0.4)', borderRadius:18, padding:'26px 20px', textAlign:'center', boxShadow:'0 16px 50px rgba(0,0,0,0.45)' }}>
          <div style={{ color:'#fff', fontWeight:800, fontSize:'1.05rem', marginBottom:6 }}>{T.shareTitle(player.firstName)}</div>
          <p style={{ color:'#c8d0e6', fontSize:'0.88rem', lineHeight:1.7, margin:'0 0 20px' }}>
            {T.shareText(player.firstName)}
          </p>
          <div style={{ display:'flex', gap:10, justifyContent:'center', flexWrap:'wrap' }}>
            <a href={`https://wa.me/?text=${encodeURIComponent(shareText)}`} target="_blank" rel="noopener noreferrer"
              style={{ display:'inline-flex', alignItems:'center', gap:9, background:'#25d366', color:'#fff', borderRadius:30, padding:'12px 26px', textDecoration:'none', fontWeight:800, fontSize:'0.95rem', boxShadow:'0 4px 20px rgba(37,211,102,0.4)' }}>
              {WA_ICON} {T.shareWA}
            </a>
            <button onClick={copyLink}
              style={{ display:'inline-flex', alignItems:'center', gap:9, background: copied ? 'rgba(37,211,102,0.16)' : 'rgba(255,255,255,0.06)', color: copied ? '#25d366' : '#dbe2f0', border:`1px solid ${copied ? 'rgba(37,211,102,0.5)' : 'rgba(212,175,55,0.35)'}`, borderRadius:30, padding:'12px 26px', cursor:'pointer', fontWeight:800, fontSize:'0.95rem', fontFamily:"'Heebo', sans-serif" }}>
              {copied ? T.linkCopied : T.copyLink}
            </button>
          </div>
        </div>
      </div>

      {/* ===== FOOTER — מיתוג יוסטאר, רקע בי־2 ===== */}
      <footer style={{
        backgroundImage: "linear-gradient(180deg, #04091a, rgba(2,6,17,0.88) 30%, rgba(2,6,17,0.94)), url('/bg2.jpg')",
        backgroundSize:'cover', backgroundPosition:'center 20%',
        borderTop:'1px solid rgba(212,175,55,0.25)', padding:'44px 20px 30px', textAlign:'center' }}>
        <div style={{ marginBottom:16 }}><BrandLockup size="big" /></div>
        <div style={{ color:'#c0cce6', fontSize:'0.9rem', lineHeight:1.7, maxWidth:520, margin:'0 auto 20px' }}>
          {T.footerCredit()}
        </div>
        <div style={{ display:'flex', flexWrap:'wrap', justifyContent:'center', gap:'12px 24px', marginBottom:24 }}>
          <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noopener noreferrer"
            style={{ display:'flex', alignItems:'center', gap:7, color:'#25d366', textDecoration:'none', fontSize:'0.88rem', fontWeight:700 }}>
            {WA_ICON} {T.waUstar}
          </a>
          <a href="tel:0546318704" style={{ display:'flex', alignItems:'center', gap:7, color:'#a8b6d8', textDecoration:'none', fontSize:'0.88rem' }}>
            {PHONE_ICON} 054-6318704
          </a>
          <a href="https://www.youtube.com/@ustarsoccer2972" target="_blank" rel="noopener noreferrer"
            style={{ display:'flex', alignItems:'center', gap:7, color:'#ff5555', textDecoration:'none', fontSize:'0.88rem' }}>
            {YT_ICON} {T.ytChannel}
          </a>
        </div>
        <div style={{ borderTop:'1px solid rgba(212,175,55,0.15)', paddingTop:20, marginTop:6 }}>
          <a href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(T.referralMsg(player.name))}`}
            target="_blank" rel="noopener noreferrer"
            style={{ display:'inline-flex', alignItems:'center', gap:6, color:'#8a9aba', textDecoration:'none', fontSize:'0.82rem', fontWeight:600 }}>
            {T.referral} {WA_ICON}
          </a>
        </div>
        <div style={{ color:'#4a5a80', fontSize:'0.78rem', marginTop:18 }}>{T.rights(new Date().getFullYear())}</div>
      </footer>
    </div>
  );
}
